export const API_ERROR_CODES = {
  FORBIDDEN: "FORBIDDEN",
  ERROR: "ERROR",
} as const;

export type ApiErrorCode =
  (typeof API_ERROR_CODES)[keyof typeof API_ERROR_CODES];

export interface ApiError {
  code: ApiErrorCode;
  message: string;
}

export const isPageApiError = (error?: ApiError): boolean =>
  error?.code === API_ERROR_CODES.FORBIDDEN;
